import { use } from "react";
import { AppModalContext } from "./AppModalContext";

export function useAppModal() {
  const appModalContext = use(AppModalContext);

  if (!appModalContext) {
    throw new Error("This Hook must be used under AppModalProvider!");
  }

  return appModalContext;
}
